<template>
  <div class="flex flex-col items-center space-y-24">
    <div
      class="text-static-default-mid body-1 flex md:justify-center"
      :class="{ 'mb-300': !features.repair.enabled }"
    >
      {{ pageDescription }}
    </div>

    <RepairCard v-if="features.repair.enabled" class="md:min-h-[319px]" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import RepairCard from '../../components/RepairCard/RepairCard.vue'

import translations from './NoPoliciesOrEligibleInsurances.translations'

const i18n = useI18n()
const { features } = useMarketplace()

const pageDescription = computed(() => {
  return features.repair.enabled
    ? i18n(translations.pageDescriptionWithRepair)
    : i18n(translations.pageDescriptionWithoutRepair)
})
</script>
